export const validateLead = (formData, isRecruit = false) => {
  const errors = {};

  if (!formData.first_name?.trim()) {
    errors.first_name = 'First name is required';
  } else if (formData.first_name.trim().length < 2) {
    errors.first_name = 'Must be at least 2 characters';
  }

  if (!formData.last_name?.trim()) {
    errors.last_name = 'Last name is required';
  } else if (formData.last_name.trim().length < 2) {
    errors.last_name = 'Must be at least 2 characters';
  }

  if (!formData.phone?.trim() && !formData.email?.trim()) {
    errors.phone = 'At least a phone or email is required';
    errors.email = 'At least a phone or email is required';
  }

  if (formData.phone?.trim()) {
    const phoneClean = formData.phone.replace(/\D/g, '');
    if (phoneClean.length < 10) {
      errors.phone = 'Enter a valid 10-digit phone number';
    }
  }

  if (formData.email?.trim()) {
    const emailRx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRx.test(formData.email)) {
      errors.email = 'Enter a valid email address';
    }
  }

  if (!isRecruit && !formData.lead_type) {
    errors.lead_type = 'Lead type is required';
  }

  return errors;
};

export const hasErrors = (errors) => Object.keys(errors).length > 0;